module.exports = __webpack_public_path__ + "img/goal.550fc22b.png";